'use client'

import {grid, gridItem} from '~/design-system/foundations'
import HgTextReveal, {
  type HgTextRevealProps,
} from '~/design-system/hg/components/HgTextReveal'

export type HgTextRevealBlockProps = HgTextRevealProps

export default function HgTextRevealBlock(props: HgTextRevealBlockProps) {
  return (
    <div className="w-full">
      <div className={grid({class: 'mx-auto pt-s12'})}>
        <div
          className={gridItem({
            class: 'md:col-span-10 md:col-start-2 lg:col-start-4',
          })}
        >
          <HgTextReveal {...props} />
        </div>
      </div>
    </div>
  )
}
